<script setup lang="ts">
import type { BlogPost } from '~/types/blog-post';

// const { data: page } = await useAsyncData('blog', () =>
//   queryContent('/blog').findOne()
// );
// if (!page.value) {
//   throw createError({
//     statusCode: 404,
//     statusMessage: 'Page not found',
//     fatal: true,
//   });
// }

const { data: posts } = await useAsyncData('posts', () =>
  queryContent<BlogPost>('/articles').where({ _extension: 'md' }).sort({ date: -1 }).find()
);

// useSeoMeta({
//   title: page.value.title,
//   ogTitle: page.value.title,
//   description: page.value.description,
//   ogDescription: page.value.description,
// });
</script>

<template>
  <BlocksHeroSection class="mb-10">Blog</BlocksHeroSection>
  <UContainer class="page-container max-w-full xl:!max-w-[67.5rem]">
    <!-- <UPageHeader v-bind="page" class="py-[50px]" /> -->

    <UPageBody class="page-body">
      <UBlogList>
        <!-- 
        
        
         -->
        <UBlogPost
          v-for="(post, index) in posts"
          :key="index"
          :to="post._path"
          :title="post.title"
          :image="post.image"
          :date="
            new Date(post.date).toLocaleDateString('en', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })
          "
          :authors="post.authors"
          :badge="post.badge"
          :description="post.description"
          :orientation="index === 0 ? 'horizontal' : 'vertical'"
          :class="[index === 0 && 'col-span-full']"
          :ui="{
            description: 'line-clamp-2',
          }"
        />
      </UBlogList>
    </UPageBody>
    <!-- <pre>{{ posts }}</pre> -->
  </UContainer>
</template>
